module.exports = __webpack_public_path__ + "img/goal.0c3ca781.svg";